import { renderIcon } from '../../SvgIcon.esm.js';

/******************************************************
 * This file was created by scripts/generate.js as part
 * of the build process. Do not edit this file directly.
 ******************************************************/
var iconType = {
  viewBox: "0 0 24 24",
  paths: [{
    d: "M5.52 3.63c.78-.78 2.05-.78 2.83 0l4.14 4.13 1.57-1.57 3.75 3.75-1.57 1.57 4.13 4.12c.78.78.78 2.05 0 2.83l-1.9 1.9c-.07.07-1.51 1.32-2.83 0l-4.13-4.13-4.62 4.62c-.09.1-.22.15-.35.15H3.5c-.28 0-.5-.22-.5-.5v-3.04c0-.14.05-.26.15-.36l4.6-4.61-4.13-4.13c-.78-.78-.78-2.05 0-2.83zm9.31 9.3l-1.9 1.9 4.13 4.13 1.9-1.9-1.27-1.27-.48.48c-.39.39-1.02.39-1.41 0a.9959.9959 0 010-1.41l.48-.48-1.45-1.45zm-7.9-7.89l-1.89 1.9 4.14 4.13 1.89-1.89-1.45-1.45-.48.48c-.39.39-1.02.39-1.41 0a.9959.9959 0 010-1.41l.47-.49-1.27-1.27zm10.03-1.75c.29-.29.94-.47 1.41 0l2.34 2.34c.39.39.39 1.02 0 1.41l-1.83 1.83-3.75-3.75z",
    fillRule: "evenodd"
  }],
  circles: []
};
var DesignServicesIcon = function DesignServicesIcon(props) {
  return renderIcon(props, iconType);
};
export { DesignServicesIcon };